<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :title="title"
    :visible="dialogVisible"
    :before-close="beforeClose"
    append-to-body
  >
    <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <el-form style="padding: 20px 20px 0 0" ref="form" :model="model" label-width="80px" :rules="rules" :inline="true">
      <el-form-item label="模型" prop="bo_def_id">
        <el-select filterable v-model="model.bo_def_id" @change="selectModel">
          <el-option v-for="item in boDefIdList" :key="item.id" :value="item.id" :label="item.description"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="表单" prop="form_key">
        <el-select v-model="model.form_key" filterable @change="selectForm">
          <el-option v-for="item in formKeyList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!--控制条件规则-->
    <rule-config-table
      ref="ruleConfigTable"
      :defId="model.bo_def_id"
      :scriptOrder="boDefIdList"
      :ruleConfigData="model.sub_bus_process_ctrl_rule_detail"
      @dataChange="changeTableData"
    ></rule-config-table>

    <div class="demo-drawer__footer">
      <el-button @click="beforeClose">取消</el-button>
      <el-button @click="submit('form')" type="primary" :loading="ruleConfigAddLoading">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import req from '@/request'
const ruleConfigTable = () => import('@/components/tenant/rule/ruleConfigTable.vue')

export default {
  name: 'RuleConfigAdd',
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    ruleConfigTable
  },
  data() {
    return {
      title: '业务规则',
      drawerSize: '70%',
      model: {
        bo_def_id: '',
        form_id: '',
        form_name: '',
        form_key: '',
        sub_bus_process_ctrl_rule_detail: []
      },
      ruleConfigAddLoading: false,
      boDefIdList: [],
      formKeyList: [],
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      rules: {
        form_key: [{ required: true, message: '请选择表单别名', trigger: 'change' }],
        bo_def_id: [{ required: true, message: '请选择模板绑定', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getBoDefIdList()
  },
  watch: {
    'model.bo_def_id'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.form_id = ''
        this.form_name = ''
        this.form_key = ''
        this.sub_bus_process_ctrl_rule_detail = []
        this.getFormKeyList(newVal)
      }
    },
    deep: true
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.ruleConfigAddLoading = true
        if (valid) {
          let isSubmit = false
          if (this.model && this.model.sub_bus_process_ctrl_rule_detail) {
            this.model.sub_bus_process_ctrl_rule_detail.forEach((ruleDetail) => {
              if (!ruleDetail.logic_operator) {
                this.$message.warning('请选择控制符')
                this.ruleConfigAddLoading = false
                isSubmit = false
                return
              }
              if (!ruleDetail.enable) {
                this.$message.warning('请选择控制方案')
                this.ruleConfigAddLoading = false
                isSubmit = false
                return
              }
              if (!ruleDetail.exception_desc) {
                this.$message.warning('请填写异常描述')
                this.ruleConfigAddLoading = false
                isSubmit = false
                return
              }
              if (ruleDetail.logic_field2.constructor === Array) {
                ruleDetail.logic_field2 = ruleDetail.logic_field2.join(',')
              }
              isSubmit = true
            })
          }
          if (isSubmit) {
            let params = Object.assign({}, this.model)
            req
              .post('${business}/rule/bus_process_ctrl_rule/', params)
              .then(() => {
                this.ruleConfigAddLoading = false
                this.beforeClose()
              })
              .catch(() => {
                this.ruleConfigAddLoading = false
              })
          }
        } else {
          this.ruleConfigAddLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    changeTableData(tableData) {
      this.model.sub_bus_process_ctrl_rule_detail = tableData
    },
    beforeClose() {
      // this.$refs["form"].resetFields();
      this.$emit('beforeClose')
      this.model = {
        bo_def_id: '',
        form_id: '',
        form_name: '',
        form_key: '',
        sub_bus_process_ctrl_rule_detail: []
      }
      this.formKeyList = []
    },
    // 获取模板用途列表
    getBoDefIdList() {
      let params
      this.pageBean.total = 0
      params = {
        pageBean: '',
        sorter: []
      }
      params.pageBean = this.pageBean
      form.getBusinessObjData(params).then((resp) => {
        this.boDefIdList = resp.rows
      })
    },
    // 获取模板用途列表
    getFormKeyList(param) {
      let params = {
        boDefId: param
      }
      form.getListByBoDefId(params).then((resp) => {
        this.formKeyList = resp
      })
    },
    selectForm(selectData) {
      this.model.form_name = this.formKeyList.find((item) => item.id === selectData).name
      this.model.sub_bus_process_ctrl_rule_detail = []
    },
    selectModel(selectData) {
      this.model.form_key = ''
      this.model.form_name = ''
      this.model.sub_bus_process_ctrl_rule_detail = []
    }
  }
}
</script>

<style scoped></style>
